/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceGroupUptimeResponse
 */
export interface DeviceGroupUptimeResponse {
    /**
     * Average of all connector uptimes. Ignores Offline/Online status.
     * @type {number}
     * @memberof DeviceGroupUptimeResponse
     */
    avgConnectorUptimesIncludeOffline?: number;
    /**
     * Average of all connector uptimes. Offline reduces connector uptimes.
     * @type {number}
     * @memberof DeviceGroupUptimeResponse
     */
    avgConnectorUptimesExcludeOffline?: number;
    /**
     * Average of all device uptimes. Ignores Offline/Online status.
     * @type {number}
     * @memberof DeviceGroupUptimeResponse
     */
    avgDeviceUptimesIncludeOffline?: number;
    /**
     * Average of all device uptimes. Offline reduces device uptimes.
     * @type {number}
     * @memberof DeviceGroupUptimeResponse
     */
    avgDeviceUptimesExcludeOffline?: number;
    /**
     * Preferred device uptime based on organisation preference. Defaults to AvgDeviceUptimesIncludeOffline if preference not set.
     * @type {number}
     * @memberof DeviceGroupUptimeResponse
     */
    preferredDeviceUptime?: number;
    /**
     * Indicates which calculation was used for PreferredDeviceUptime. true = offline included, false = offline excluded.
     * @type {boolean}
     * @memberof DeviceGroupUptimeResponse
     */
    isOfflineIncludedInDeviceUptime?: boolean;
    /**
     * Preferred connector uptime based on organisation preference. Defaults to AvgConnectorUptimesIncludeOffline if preference not set.
     * @type {number}
     * @memberof DeviceGroupUptimeResponse
     */
    preferredConnectorUptime?: number;
    /**
     * Indicates which calculation was used for PreferredConnectorUptime. true = offline included, false = offline excluded.
     * @type {boolean}
     * @memberof DeviceGroupUptimeResponse
     */
    isOfflineIncludedInConnectorUptime?: boolean;
    /**
     * Calculation period start.
     * @type {Date}
     * @memberof DeviceGroupUptimeResponse
     */
    periodStart?: Date;
    /**
     * Calculation period end.
     * @type {Date}
     * @memberof DeviceGroupUptimeResponse
     */
    periodEnd?: Date;
}

/**
 * Check if a given object implements the DeviceGroupUptimeResponse interface.
 */
export function instanceOfDeviceGroupUptimeResponse(
    value: object,
): value is DeviceGroupUptimeResponse {
    return true;
}

export function DeviceGroupUptimeResponseFromJSON(
    json: any,
): DeviceGroupUptimeResponse {
    return DeviceGroupUptimeResponseFromJSONTyped(json, false);
}

export function DeviceGroupUptimeResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceGroupUptimeResponse {
    if (json == null) {
        return json;
    }
    return {
        avgConnectorUptimesIncludeOffline:
            json["avgConnectorUptimesIncludeOffline"] == null
                ? undefined
                : json["avgConnectorUptimesIncludeOffline"],
        avgConnectorUptimesExcludeOffline:
            json["avgConnectorUptimesExcludeOffline"] == null
                ? undefined
                : json["avgConnectorUptimesExcludeOffline"],
        avgDeviceUptimesIncludeOffline:
            json["avgDeviceUptimesIncludeOffline"] == null
                ? undefined
                : json["avgDeviceUptimesIncludeOffline"],
        avgDeviceUptimesExcludeOffline:
            json["avgDeviceUptimesExcludeOffline"] == null
                ? undefined
                : json["avgDeviceUptimesExcludeOffline"],
        preferredDeviceUptime:
            json["preferredDeviceUptime"] == null
                ? undefined
                : json["preferredDeviceUptime"],
        isOfflineIncludedInDeviceUptime:
            json["isOfflineIncludedInDeviceUptime"] == null
                ? undefined
                : json["isOfflineIncludedInDeviceUptime"],
        preferredConnectorUptime:
            json["preferredConnectorUptime"] == null
                ? undefined
                : json["preferredConnectorUptime"],
        isOfflineIncludedInConnectorUptime:
            json["isOfflineIncludedInConnectorUptime"] == null
                ? undefined
                : json["isOfflineIncludedInConnectorUptime"],
        periodStart:
            json["periodStart"] == null
                ? undefined
                : new Date(json["periodStart"]),
        periodEnd:
            json["periodEnd"] == null ? undefined : new Date(json["periodEnd"]),
    };
}

export function DeviceGroupUptimeResponseToJSON(
    value?: DeviceGroupUptimeResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        avgConnectorUptimesIncludeOffline:
            value["avgConnectorUptimesIncludeOffline"],
        avgConnectorUptimesExcludeOffline:
            value["avgConnectorUptimesExcludeOffline"],
        avgDeviceUptimesIncludeOffline: value["avgDeviceUptimesIncludeOffline"],
        avgDeviceUptimesExcludeOffline: value["avgDeviceUptimesExcludeOffline"],
        preferredDeviceUptime: value["preferredDeviceUptime"],
        isOfflineIncludedInDeviceUptime:
            value["isOfflineIncludedInDeviceUptime"],
        preferredConnectorUptime: value["preferredConnectorUptime"],
        isOfflineIncludedInConnectorUptime:
            value["isOfflineIncludedInConnectorUptime"],
        periodStart:
            value["periodStart"] == null
                ? undefined
                : value["periodStart"].toISOString(),
        periodEnd:
            value["periodEnd"] == null
                ? undefined
                : value["periodEnd"].toISOString(),
    };
}
